import React, { useContext, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _, { isEmpty } from 'lodash';
import {
    ModalNextContext,
    Loader,
    Icon,
    FormattedDate,
    useModal,
    ModalNextEmitter,
} from '@jutro/components';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { DigitalWizardCustPageTemplate } from 'gw-portals-wizard-components-ui';
import { withRouter } from 'react-router-dom';
import { LobIconUtil } from '@xengage/gw-portals-util-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import moment from 'moment';
import { PolicyService } from 'gw-capability-policy';
import { getNormalizedLOBName } from '@xengage/gw-portals-config-js';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { fnolCommonMessages as messages } from 'gw-capability-fnol-common-react';
import { LoaderExt } from 'gw-components-platform-react';
import Claim from '../../models/Claim';
import styles from './FNOLSelectPolicy.module.scss';
import metadata from './FNOLSelectPolicy.metadata.json5';
// import messages from '../../FNOL.messages';
import usecpmiAnalytics from '../../../../hooks/usecpmiAnalytics';
import useGoogleAnalytics from '../../../../hooks/useGoogleAnalytics';
import { AccountDropDownValues } from '../../../cpmi_SelectAccountDropDown';

function FNOLSelectPolicy(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history,
        basePath,
        steps,
        goNext,
        showConfirm,
        // ModalNextEmitter:modalNext,
        history: {
            location: { state },
        },
        
    } = props;
    
    const modalNext = useContext(ModalNextEmitter);
    // const {showConfirm,showAlert} = useModal()
    const {
        accountNumber: accountNumberFromPrevPage,
        policyNumber: policyNumberFromPrevPage,
        redirectPath,
        claimNumber,
        claimStatus,
    } = state || {};
    const { FNOLService } = useDependencies('FNOLService');
    const { ClaimService } = useDependencies('ClaimService');
    const { AccountService } = useDependencies('AccountService');
    const translator = useTranslator();
    const [policyData, setPolicyData] = useState({});
    const [donotShowDOI, setdonotShowDOI] = useState(true);
    const [policyNumber, setPolicyNumber] = useState(policyNumberFromPrevPage);
    const [accountNumber, setAccountNumber] = useState(
        accountNumberFromPrevPage
    );
    const [isLoading, setIsLoading] = useState(true);
    const [isShowInfoMessage, setInfoMessage] = useState(false);
    const { authHeader } = useAuthentication();
    const { isComponentValid, registerComponentValidation } = useValidation(
        'FNOLSelectPolicy'
    );
    const [searchPolicyResponse, setSearchPolicyResponse] = useState([]);
    const [trackPageView, trackEvent] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const [lossDateMessage, setLossDateMessage] = useState({});
    const [fileAClaimAccount, setFileAClaimAccount] = useState(null);
    const [tempPolicyData, setTempPolicyData] = useState({});
    const [firstRender,setFirstRender]=useState(true)

    const getFormattedDate = useCallback((items, index, property) => {
        if (typeof items[property.id] === 'undefined') {
            return '';
        }
        return moment(items[property.id]).format('MM/DD/YYYY');
    }, []);

    const processResponseData = useCallback(accountDetails => {
        const policyDetails = [];
        if (appConfig.persona === 'policyholder') {
            accountDetails.forEach(policyInfo => {
                const policy = {
                    account:policyInfo.accountNumber,
                    product: policyInfo.policyNumber,
                    policyNumber: policyInfo.policyNumber,
                    productType: policyInfo.policyType,
                    effectiveDate: policyInfo.effectiveDate,
                    expirationDate: policyInfo.expirationDate,
                    state: !_.isEmpty(policyInfo.states)
                        ? policyInfo.states
                        : [policyInfo.state],
                    coverage: policyInfo.coverages
                };
                policyDetails.push(policy);
            });
        } else {
            const lobindex = 0;
            const allowedPolicy = appConfig.allowedPolicyTypes;
            accountDetails.policySummaries.forEach(policyInfo => {
                const { isCancelled } = policyInfo;
                const businessLines = policyInfo.policyLines;
                const { productName } = policyInfo.product;
                const businessLine = businessLines[lobindex].lineOfBusinessCode;
                if (
                    productName !== 'Commercial Package' &&
                    _.includes(allowedPolicy, businessLine) &&
                    !isCancelled &&
                    !moment().isBefore(moment(policyInfo.effective))
                ) {
                    const policy = {
                        product: policyInfo.policyNumber,
                        policyNumber: policyInfo.policyNumber,
                        productType: businessLine,
                        effectiveDate: policyInfo.effective,
                        expirationDate: policyInfo.expiration,
                        state: !_.isEmpty(policyInfo.states)
                            ? policyInfo.states
                            : policyInfo.state,
                        coverage:policyInfo.coverages
                    };
                    policyDetails.push(policy);
                }
            });
        }
        return policyDetails;
    }, []);

    const checkPageSkipped = useCallback(() => {
        const stepsWithoutSelectPolicy = steps.slice(1, steps.length);
        return (
            basePath !== '/fnol-select-policy' &&
            !stepsWithoutSelectPolicy.some(step => step.visited)
        );
    }, [basePath, steps]);

    const getPolicyLocations = async (policyNum, selLossDate, auth) => {
        const loc = await PolicyService.getPolicyLocations(policyNum, selLossDate, auth)
        return loc;
    }

    const getPolicyDetails = useCallback(
        selectedAccountNumber => {
            let selectedPolicies = [];
            let promises = [];
            if (props.location.state.claimNumber === undefined) {
                if (!checkPageSkipped()) {
                    if (appConfig.persona === 'policyholder') {
                        const policySearchCriteria = {
                            lossDate: _.get(claimVM.value, 'lossDate'),
                        };
                        FNOLService.searchPolicies(
                            policySearchCriteria,
                            authHeader
                        ).then(response => {
                            response.forEach((policy) => {                                                                 
                                selectedPolicies.push(policy);
                            })
                            Promise.all(promises).then(() => {
                                setPolicyData(processResponseData(selectedPolicies));
                                setTempPolicyData(processResponseData(selectedPolicies));
                                setSearchPolicyResponse(selectedPolicies);
                                setIsLoading(false);
                            });
                        });
                    } else {
                        AccountService.getAccountDetails(
                            selectedAccountNumber,
                            authHeader
                        ).then(response => {
                            setPolicyData(processResponseData(response));
                            setTempPolicyData(processResponseData(response))
                            setIsLoading(false);
                        });
                        
                    }
                }
            }
        },
        [
            props.location.state.claimNumber,
            checkPageSkipped,
            claimVM.value,
            FNOLService,
            authHeader,
            processResponseData,
            AccountService,
        ]
    );

    
    const redirectDraftClaimFlow = useCallback(() => {
        setIsLoading(true);
        if (_.isFunction(ClaimService.addRecentlyViewedClaim)) {
            ClaimService.addRecentlyViewedClaim(claimNumber, authHeader);
        }
        return FNOLService.getClaim(claimNumber, authHeader).then(
            getClaimResponse => {
                setPolicyNumber(getClaimResponse.policy.policyNumber);
                claimVM.value = getClaimResponse;
                const normalizedLobCode = getNormalizedLOBName(
                    claimVM.value.policy.policyType
                );
                setIsLoading(false);
                return history.push({
                    pathname: `/fnol-${normalizedLobCode}`,
                    state: {
                        claimData: getClaimResponse,
                        redirectPath: redirectPath,
                        claimStatus: claimStatus,
                    },
                });
            }
        );
    }, [
        ClaimService,
        claimNumber,
        authHeader,
        FNOLService,
        claimVM,
        history,
        redirectPath,
        claimStatus,
        setPolicyNumber,
    ]);

    useEffect(() => {
        if(claimVM.value.lossDate==='')
        {
            trackPageView('FNOL', '/fnol');
            trackEvent("FNOL Select Policy","/select-policy");
            trackGAPageView("/select-policy","FNOL Select Policy")
            
        }
      
    }, []);

   

    useEffect(() => {
        if (!_.isEmpty(claimNumber)) {
            redirectDraftClaimFlow();
        }
        if (checkPageSkipped()) {
            goNext();
        }
        // This will call only once.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const previousAccountNumber = _.get(
            claimVM.value,
            'policy.accountNumber'
        );

        const policyNumberVar = _.isNil(policyNumber)
            ? _.get(claimVM.value, 'policy.policyNumber')
            : policyNumber;
        setPolicyNumber(policyNumberVar);
        setAccountNumber(accountNumberFromPrevPage || previousAccountNumber);
        const flowCheck = redirectPath.split('/');
        if (
            (flowCheck[1] === 'accounts' &&
                claimStatus !==
                    translator({
                        id: 'typekey.ClaimState.draft',
                        defaultMessage: 'draft',
                    }) &&
                (!_.isEmpty(accountNumberFromPrevPage) ||
                    !_.isEmpty(previousAccountNumber))) ||
            appConfig.persona === 'policyholder'
        ) {
            getPolicyDetails(
                accountNumberFromPrevPage || previousAccountNumber
            );
        } else {
            setIsLoading(false);
        }
        // This will call only once.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changePolicy = useCallback(() => {
        const previousLossDate = _.get(claimVM.value, 'lossDate');
        claimVM.value = new Claim();
        _.set(claimVM.value, 'lossDate', previousLossDate);
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData]);

    const getFNOLServiceDetails = useCallback(async () => {
        claimVM.value = new Claim(claimVM.value);
        // updateWizardData(claimVM);
        return await FNOLService.getFNOLDetails(
            policyNumber,
            claimVM.value,
            authHeader
        ).then(res => {
            // updateWizardData(res);
            return res;
        });
    }, [policyNumber, claimVM, FNOLService, authHeader]);
 
    const onNext = useCallback(() => {
       _.set(claimVM.value, 'fnolSelectPolicyPage', "false");
        if (
            _.isEmpty(searchPolicyResponse) &&
            basePath === '/fnol-select-policy'
        ) {
            setInfoMessage(true);
            return claimVM;
        }

        if (_.isEmpty(searchPolicyResponse)) {
            setInfoMessage(true);
            
            return false;
        }

        const InjuredData = {
            bodyParts: [],
            description: null,
            detailedInjuryType: null,
            generalInjuryType: "specific",
            
            injuredAddress: {
                addressLine1: null,
                addressLine2: null,
                addressLine3: null,
                addressType: "home",
                city: null,
                country: "US",
                postalCode: null,
                state: null,
            },
        };
        

        
        _.set(claimVM.value, 'policy', searchPolicyResponse[0]);
        _.set(claimVM.value, 'policy.accountNumber', accountNumber);
        _.set(claimVM.value,'lobs.workersComp.injuryIncident',InjuredData)
       
        claimVM.onFastTrack = false;
        claimVM.value = new Claim(claimVM.value);
        delete claimVM.value.policy.coverages
        return FNOLService.getFNOLDetails(
            policyNumber,
            claimVM.value,
            authHeader
        ).then(res => {
            // updateWizardData(res);
            claimVM.value = res;

            const normalizedCode = getNormalizedLOBName(
                claimVM.value.policy.policyType
            );
            const fnolPath = `/fnol-${normalizedCode}`;
            if (history.location.pathname.includes(fnolPath)) {
                return claimVM;
            }
            // updateWizardData(claimVM.value)
            return history.push({
                pathname: fnolPath,
                state: {
                    claimData: claimVM.value,
                    redirectPath: redirectPath,
                  
                },
            });
        });
    }, [
        policyNumber,
        claimVM,
        FNOLService,
        authHeader,
        basePath,
        accountNumber,
        history,
        redirectPath,
        searchPolicyResponse
    ]);

    const callFNOLPolicyService = useCallback(() => {
        const policySearchCriteria = {
            policyNumber: policyNumber,
            lossDate: _.get(claimVM.value, 'lossDate'),
        };
        claimVM.value.onFastTrack = false;
        claimVM.lossType = 'WC';
        claimVM.lossCause = 'burn_scald';
        // claimVM.value = new Claim(claimVM.value);

        return FNOLService.getFNOLDetails(
            policyNumber,
            claimVM.value,
            authHeader
        ).then(policyResponse => {
            if (
                _.isEmpty(policyResponse) &&
                basePath === '/fnol-select-policy'
            ) {
                setInfoMessage(true);
                return claimVM;
            }
            if (_.isEmpty(policyResponse)) {
                setInfoMessage(true);
                return false;
            }
            _.set(claimVM.value, 'policy', policyResponse[0]);
            _.set(claimVM.value, 'policy.accountNumber', accountNumber);
            // return claimVM;
            const normalizedLobCode = getNormalizedLOBName(
                claimVM.value.policy.policyType
            );
            const fnolLOBPath = `/fnol-${normalizedLobCode}`;
            // if the URL contains the lob code, we have already navigated from the first step
            // and do not need to force the redirect to `/fnol-${normalizedLobCode}`
            if (history.location.pathname.includes(fnolLOBPath)) {
                return claimVM;
            }
           
            return history.push({
                pathname: fnolLOBPath,
                state: {
                    claimData: claimVM,
                    redirectPath: 'what',
                },
            });
        });
    }, [
        policyNumber,
        claimVM,
        FNOLService,
        authHeader,
        basePath,
        accountNumber,
        history,
    ]);

    const onPolicySelect = useCallback(
        selectedValue => {
            if (_.get(claimVM.value, 'policy.accountNumber')) {
                setAccountNumber(_.get(claimVM.value, 'policy.accountNumber'));
            }
            _.set(claimVM.value, 'selectedPolicy', selectedValue);
            updateWizardData(claimVM);
            setPolicyNumber(selectedValue);
        },
        [claimVM, updateWizardData]
    );

    const getCell = useCallback((item, index, property) => {
        return <span>{item[property.id]}</span>;
    }, []);

    const generateDataForRadioButton = useCallback(row => {
        return {
            code: row.policyNumber,
            value: '',
        };
    }, []);

    const getProductImage = useCallback(item => {
        const icon = LobIconUtil.getFontIcon(item.productType);
        return <Icon icon={icon} title={item.productCode} />;
    }, []);

    const dateIsInFuture = useCallback(date => {
        if (!date) {
            return false;
        }

        const currentTime = new Date();
        const selectedDate = new Date(date);
        return selectedDate > currentTime;
    }, []);

    const isPageValid = useCallback(() => {
        if (
            _.isEmpty(policyNumber) &&
            _.isEmpty(_.get(claimVM.value, 'policy.policyNumber'))
        ) {
            return false;
        }
        if (!_.get(claimVM.value, 'lossDate')) {
            return false;
        }
        if(moment(_.get(claimVM.value, 'lossDate')).isAfter(moment(new Date())))
        {
            return false;
        }
        return true;
    }, [claimVM.value, policyNumber]);

    useEffect(() => {
        registerComponentValidation(isPageValid);
    }, [isPageValid, registerComponentValidation]);

    const getSelectPolicyHeading = useCallback(() => {
        return (
            <><p className="policySubHeading">
                To expedite your experience, first complete an&nbsp;
                <a
                    href="https://www.copperpoint.com/insurance-claims/workers-comp-claims-kit"
                    target="_blank"
                    className={styles.employersInjury}
                >
                    Employer's report of injury&nbsp;
                </a>
                (select Resource: Claims Kit for your state) prior to this online submission. The form can be uploaded on the next screen.
                <span className={styles.boldText}>This form will speed the submission process and minimize the questions asked from your adjuster.</span>
            </p>
            
            <p>Note: This system will <span className={styles.boldText}>not</span> produce a completed form for submission to the state.</p>
            </>
        );
    }, []);

    const searchPolicies = useCallback( 
        value => {
            setIsLoading(true);
            let policies = [];
            let searchPromise = [];
            
            _.set(claimVM.value, 'lossDate', value);
            if(claimVM.value.fnolSelectPolicyPage!="true"){
                _.set(claimVM.value, 'fnolSelectPolicyPage', "true");
            }
            updateWizardData(claimVM);
            const policysearchparams = {
                // policyNumber: policyNumber,
                lossDate: _.get(claimVM.value, 'lossDate'),
            };
            setPolicyNumber('')
            return FNOLService.searchPolicies(
                policysearchparams,
                authHeader
            ).then(response => {
                response.forEach((policy) => {                    
                    policies.push(policy);
                });
                Promise.all(searchPromise).then(() => {
                    setPolicyData(processResponseData(policies));
                    setTempPolicyData(processResponseData(policies))
                    setSearchPolicyResponse(policies)
                });
                response.length === 0
                    ? setInfoMessage(true)
                    : setInfoMessage(false);
                    setIsLoading(false);
            });
        },
        [
            claimVM,
            updateWizardData,
            FNOLService,
            authHeader,
            processResponseData,
        ]
    );

    const getStates = useCallback(row => {
        return row.state.length > 1 ? row.state.sort().join(', ') : row.state;
    });
    

    const getCoverages = useCallback(row => {
        const transitionObject = [
            {key:"state",value:"State Workers' Comp"},
            {key:"defenseBaseAct",value:"Defense Base"},
            {key:"longshoreAndHarbor",value:"USL&H"},
            {key:"migrantAndSeasonalAgricultural",value:"Agricultural Worker"},
            {key:"nonappropriatedFundInstrumentalities",value:"Civilian Employees"},
            {key:"outerContinentalShelfLands",value:"Outer Continental Shelf"},
            {key:"admiraltyLaw",value:"Admiralty Law"},
            {key:"FELA",value:"FELA"},
            {key:"watersNonAdmiralty",value:"Waters Not Subject To Admiralty"}
        ]
        const coveragesObj = row.coverage;
        const arrayResult = []
        if (coveragesObj?.length === 0) {
            return 'Not Available'
        } 
        if(coveragesObj?.length > 0) {

            coveragesObj.forEach((element) => {
                for(const u in transitionObject){
                    if(element ===transitionObject[u].key){
                        arrayResult.push(transitionObject[u].value);
                    }
                }
            });
            return arrayResult.sort().join(', ');
        }
          
    });

    const validateDate = e => {
        const dt = document.querySelector('input[id^="lossDateId"]');
        const date = dt.getAttribute('value');
        const dateFormat = 'MM-DD-YYYY';
        const toDateFormat = moment(new Date(date)).format(dateFormat);
        if(!moment(toDateFormat, dateFormat, true).isValid())
        {
            setLossDateMessage("Date must be in the correct format: MM/DD/YYYY")
        }
        else{
            setLossDateMessage("")
        }
      
    };

    const verifyLossDate = (() => {
        if(!_.isEmpty(lossDateMessage))
        {
            return [lossDateMessage];
        }
        return []
       
    })

    const getButtonDisability=useCallback(()=>{
        if(isComponentValid && !isShowInfoMessage)
        {
            return false
        }
        return true

    },[isComponentValid, isShowInfoMessage])

    const handleValueChange=(value)=>{
            setFileAClaimAccount(value);
    }


    useEffect(()=>{
        
        const filteredPolicyData=[]
        for(let i=0;i<tempPolicyData.length;i++){
            if(tempPolicyData[i].account===fileAClaimAccount){
                    filteredPolicyData.push(tempPolicyData[i])
            }
        }
        setPolicyData(filteredPolicyData)
        
    },[fileAClaimAccount, tempPolicyData])

    const overrides = {
        policyTable: {
            data: policyData,
        },
        policyTableHeadingId: {
            visible: policyData.length > 0,
        },
        selectPolicySubheading: {
            content: getSelectPolicyHeading(),
            visible:  ((state.page==="LandingPage" && (fileAClaimAccount!==null )) || state.page!=="LandingPage" && (fileAClaimAccount!==null )),
        },
        policyLossDateHeadingId: {
            content: 'Date of Loss?',
            visible:  ((state.page==="LandingPage" && (fileAClaimAccount!==null )) || state.page!=="LandingPage" && (fileAClaimAccount!==null ))
        },
        policySelectRadio: {
            option: generateDataForRadioButton,
            value:
                policyNumber ||
                (!_.isEmpty(claimVM.value) &&
                    _.get(claimVM.value, 'policy.policyNumber')),
            onValueChange: onPolicySelect,
        },
        noPolicyInfoLableId: {
            visible: isShowInfoMessage,
        },
        lossDateId: {
           // defaultValue: new Date(),
            phoneWideTime: {
                labelPosition: 'top',
            },
            onValueChange: e => {
                searchPolicies(e);
            },
            contentContainerClassName: 'lossDatePicker',

            onBlur: e => validateDate(e),
            validationMessages:verifyLossDate(),
            visible: ((state.page==="LandingPage" && (fileAClaimAccount!==null )) || state.page!=="LandingPage" && (fileAClaimAccount!==null ))
        },
        availableProducerCode:{
            removeSelected:state.page==="LandingPage" && (fileAClaimAccount===null )
        },
        snapshotDetailstestNew:{
            visible:fileAClaimAccount===null?true:fileAClaimAccount!==null?true:false,
            className:fileAClaimAccount===null?"accountDropdownStyle":fileAClaimAccount!==null?"accountDropdownStyleNew":"accountDropdownStyle",
            
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            getCell: getCell,
            getFormattedDate: getFormattedDate,
            getProductImage: getProductImage,
            getStates: getStates,
            getCoverages: getCoverages,
            handleValueChange,

        },
        resolveClassNameMap: styles,
        resolveComponentMap:{
            AccountDropDownValues: AccountDropDownValues
        }
    };
    if (isLoading) {
        return <LoaderExt loaded={!isLoading} showLoadingText = {true} />;
    }
    if(fileAClaimAccount===null || fileAClaimAccount===undefined){
        return(
            
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
            
        )
    }
    return (
        <WizardPage
            onNext={onNext}
            showPrevious={false}
            disableNext={getButtonDisability()}
            template={DigitalWizardCustPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
        
        
    );
}

FNOLSelectPolicy.propTypes = wizardProps;
FNOLSelectPolicy.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};

export default withRouter(FNOLSelectPolicy);
